import { getResourcesForPage as getResourcesForPage$1 } from '@pm2/api';
import { findPageDescriptorById } from './util.find-page-descriptor-by-id.js';

function getResourcesForPage(configStore, sitemapStore, pageDescriptor) {
  let currPageDescriptor = pageDescriptor;
  const pagesWithResources = [];
  while (currPageDescriptor !== void 0) {
    if (currPageDescriptor.hasResources) {
      pagesWithResources.push(currPageDescriptor);
    }
    if (currPageDescriptor.parentId && (currPageDescriptor.type === "Chapter" || currPageDescriptor.type === "ChapterGroup" || currPageDescriptor.type === "TeachersGuidePage")) {
      currPageDescriptor = findPageDescriptorById(
        sitemapStore.getState(),
        currPageDescriptor.parentId
      );
    } else {
      currPageDescriptor = void 0;
    }
  }
  const pagesWithMissingResources = pagesWithResources.filter(
    (it) => !it.resources
  );
  if (pagesWithMissingResources.length > 0) {
    return Promise.all(
      pagesWithMissingResources.map(
        (it) => fetchResourcesForPage(configStore, sitemapStore, it)
      )
    ).then((fetchedResources) => [
      ...fetchedResources.flatMap((it) => it),
      ...pagesWithResources.flatMap((it) => it.resources ?? [])
    ]);
  }
  return pagesWithResources.flatMap((it) => it.resources ?? []);
}
async function fetchResourcesForPage(configStore, sitemapStore, pageDescriptor) {
  const configState = configStore.getState();
  const resources = await getResourcesForPage$1(
    configState.config.id,
    pageDescriptor.id,
    {
      previewMode: configState.previewMode
    }
  );
  sitemapStore.dispatch(
    sitemapStore.actions.updatePageDescriptor({
      ...pageDescriptor,
      resources
    })
  );
  return resources;
}

export { getResourcesForPage };
//# sourceMappingURL=util.get-resources-for-page.js.map
